module.exports = __webpack_public_path__ + "static/media/logo-irev.bedfa87a.svg";